// Model.js
// -----------------------
// @module Case
define("nowak.cloudflareRecaptchaExt.cloudflareRecaptchaExt.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/cloudflareRecaptchaExt/SuiteScript2/cloudflareRecaptchaExt.Service.ss"
            ),
            true
        )
});
});
